<template>
  <div class="repayment-plan">
    <div class="title">
      <div class="left">还款计划</div>
      <div class="right">
        <span class="span"
          >共{{
            pendingPlan.fakePlanRespList &&
            pendingPlan.fakePlanRespList.length > 0
              ? pendingPlan.fakePlanRespList.length
              : 0
          }}期，</span
        >
        <span>每期还款计划如下</span>
      </div>
    </div>
    <!-- 还款计划列表 -->
    <div
      class="list"
      v-if="
        pendingPlan.fakePlanRespList && pendingPlan.fakePlanRespList.length > 0
      "
    >
      <div class="servicefee-wrap" v-if="pendingPlan.serviceFee > 0">
        <div class="top">
          <div class="item-left">
            <span class="span">服务费</span>
            <span>还款日期：{{ pendingPlan.serviceFeeRepaymentTime }}</span>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom-left">
            <span class="span">产品服务费</span>
          </div>
          <div class="bottom-right">
            <span class="amount-tip">￥</span>
            <div>
              {{ (pendingPlan.serviceFee).toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in pendingPlan.fakePlanRespList" :key="index">
        <repaymentPlanItem
          :item="item"
          :num="
            pendingPlan.fakePlanRespList &&
            pendingPlan.fakePlanRespList.length > 0
              ? pendingPlan.fakePlanRespList.length
              : 0
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import repaymentPlanItem from "./repaymentPlanItem.vue";
export default {
  name: "RepaymentPlan",
  components: {
    repaymentPlanItem,
  },
  props: {
    pendingPlan: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.repayment-plan {
  background: #ffffff;
  border-radius: 8px;
  margin-top: 16px;
  padding: 14px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;

    .left {
      font-weight: 600;
      font-size: 17px;
    }

    .right {
      font-size: 14px;

      .span {
        color: #1d70f7;
      }
    }
  }
}
.servicefee-wrap {
  height: 76px;
  background-image: url("@/assets/style/servicefee-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.04), 0px 4px 7px 0px rgba(0,0,0,0.03);
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
  color: #1D70F7;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-left {
      display: flex;
      align-items: center;
      font-size: 14px;
      .span {
        margin-right: 7px;
        padding: 2px 0px;
        border-radius: 4px;
        color: #1D70F7;
        font-weight: 600;
        background: #FFFFFF;
        border: 1px solid #1D70F7;
        text-align: center;
        width: 46px;
        font-size: 12px;
      }
    }
    .item-right {
      font-size: 10px;
      padding: 2px 4px;
      border-radius: 4px;
      background: #fff;
      color: #01abff;
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .bottom-left {
      display: flex;
      align-items: center;
      .span {
        font-size: 13px;
        font-family: YEFONTAoYeHei, YEFONTAoYeHei;
        padding: 1px 4px;
        border-radius: 4px;
      }
    }
    .bottom-right {
      font-weight: 600;
      font-size: 20px;
      display: flex;
      align-items: center;
      .amount-tip{
        font-size: 14px;
      }
    }
  }
}
</style>
